import { ArrowLeft, Eye, EyeOff } from "lucide-react";
import { FormEvent, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Logo } from "../components/Logo";
import { ApiError } from "../lib/api";

export function LoginPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { login } = useAuth();
  const requestedNext = params.get("next");
  const safeNext = requestedNext?.startsWith("/") && !requestedNext.startsWith("//") ? requestedNext : null;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const snapshot = await login(email, password);
      navigate(safeNext ?? (snapshot.license?.status === "active" ? "/app" : "/activate"), { replace: true });
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : "No pudimos iniciar sesión");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-top"><Link to="/" className="icon-link"><ArrowLeft size={20} /></Link><Logo compact /></div>
      <div className="auth-card">
        <div className="auth-heading"><span className="step-label">Bienvenido de vuelta</span><h1>Ingresá a LingoSound</h1><p>Usá el email con el que activaste o compraste tu XR4.</p></div>
        <form onSubmit={submit} className="form-stack">
          <label>Email<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" placeholder="tu@email.com" required /></label>
          <label>Contraseña<div className="password-field"><input type={visible ? "text" : "password"} value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" placeholder="Tu contraseña" required /><button type="button" onClick={() => setVisible((value) => !value)} aria-label="Mostrar contraseña">{visible ? <EyeOff size={19} /> : <Eye size={19} />}</button></div></label>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="button primary large" disabled={busy}>{busy ? "Ingresando…" : "Ingresar"}</button>
        </form>
        <p className="support-note"><Link to="/forgot-password">¿Olvidaste tu contraseña?</Link></p>
        <p className="auth-footer">¿Todavía no tenés cuenta? <Link to={safeNext ? `/register?next=${encodeURIComponent(safeNext)}` : "/register"}>Crear cuenta</Link></p>
      </div>
    </div>
  );
}
